import React, { useState } from "react"
import { addEditDataAPI } from "services/CRUDServices"
import { handleDownload } from "./export-excel-formula"
import { ClipLoader } from "react-spinners"
import TooltipWrapper from "global/tooltip/TooltipWrapper"
import { RiFileExcel2Line } from "react-icons/ri"

function ExportExcelFormulaButton({index, item}) {

  const [loadingIndex, setLoadingIndex] = useState()
  const [exportExcelLoading, setExportExcelLoading] = useState(false)
  return (
    <button
      className=" border-none	 text-[14px]  w-[20px] h-[20px] "
      onClick={async () => {
        setLoadingIndex(index)
        try {
          setExportExcelLoading(true)
          const response = await addEditDataAPI(
            `/consignment-api/consignment/exchange/v3/findAllByConsignmentPriceFromHubDateBetweenList/${item.creditRecipientHubId}/${item.id}`,
            "post",

            {
              from: item.creditValidFrom,
              to: item.creditValidTo,
            }
          )

          handleDownload(
            {
              ...item.findAllByConsignmentPriceFromHub.detailPrice,
              percentage: item.findAllByConsignmentPriceFromHub.percentage,
              totalPayment:item.totalPayment,
              totalDepositToHub:item.totalDepositToHub
            },
            response.data
          )
          setExportExcelLoading(false)
        } catch {
          setExportExcelLoading(false)
        }
      }}
    >
      {loadingIndex === index && exportExcelLoading ? (
        <ClipLoader size={20} />
      ) : (
        <TooltipWrapper textProps={"خروجی محاسبات"}>
          <RiFileExcel2Line className="w-full h-full" />
        </TooltipWrapper>
      )}
    </button>
  )
}

export default ExportExcelFormulaButton
